import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  ExpectedDelivery,
  ExpectedDeliveryCreateParams,
  ExpectedDeliveryReceipt
} from '../_models/expected-delivery.interface';

export interface ExpectedDeliveryFilterParams {
  status?: string;
  supplier_name?: string;
  created_by_id?: number;
  customer_id?: number;
  project_id?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ExpectedDeliveryService {
  private basePath = environment.apiURL + 'expected_deliveries';

  constructor(private http: HttpClient) {}

  /**
   * Alle erwarteten Lieferungen abrufen (mit optionalen Filtern)
   */
  public getAll(filters?: ExpectedDeliveryFilterParams): Observable<ExpectedDelivery[]> {
    let params = new HttpParams();
    if (filters) {
      if (filters.status) params = params.set('status', filters.status);
      if (filters.supplier_name) params = params.set('supplier_name', filters.supplier_name);
      if (filters.created_by_id) params = params.set('created_by_id', filters.created_by_id.toString());
      if (filters.customer_id) params = params.set('customer_id', filters.customer_id.toString());
      if (filters.project_id) params = params.set('project_id', filters.project_id.toString());
    }
    return this.http.get<ExpectedDelivery[]>(`${this.basePath}.json`, { params });
  }

  /**
   * Einzelne erwartete Lieferung abrufen
   */
  public getById(id: number | string): Observable<ExpectedDelivery> {
    return this.http.get<ExpectedDelivery>(`${this.basePath}/${id}.json`);
  }

  /**
   * Neue erwartete Lieferung erstellen
   */
  public create(data: ExpectedDeliveryCreateParams): Observable<{ success: boolean; id: number; expected_delivery: ExpectedDelivery }> {
    return this.http.post<{ success: boolean; id: number; expected_delivery: ExpectedDelivery }>(
      `${this.basePath}.json`,
      { expected_delivery: data }
    );
  }

  /**
   * Erwartete Lieferung aktualisieren
   */
  public update(id: number | string, data: Partial<ExpectedDeliveryCreateParams>): Observable<{ success: boolean; expected_delivery: ExpectedDelivery }> {
    return this.http.put<{ success: boolean; expected_delivery: ExpectedDelivery }>(
      `${this.basePath}/${id}.json`,
      { expected_delivery: data }
    );
  }

  /**
   * Erwartete Lieferung stornieren
   */
  public cancel(id: number | string): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${this.basePath}/${id}/cancel.json`, {});
  }

  /**
   * Erwartete Lieferung löschen (nur wenn keine Wareneingänge gebucht wurden)
   */
  public delete(id: number | string): Observable<{ success: boolean; message: string }> {
    return this.http.delete<{ success: boolean; message: string }>(`${this.basePath}/${id}.json`);
  }

  /**
   * Wareneingänge-Historie abrufen
   */
  public getHistory(id: number | string): Observable<ExpectedDeliveryReceipt[]> {
    return this.http.get<ExpectedDeliveryReceipt[]>(`${this.basePath}/${id}/history.json`);
  }
}
